import { STORAGE_KEYS } from '@app/domain/ports';
import type { ICryptoAdapter, IMetadataKeyRepository } from '@app/domain/ports';
import { toArrayBuffer } from '../utils/array-buffer.utils';

export class EncryptedDatabaseSnapshotWriter {
  constructor(
    private readonly crypto: Pick<ICryptoAdapter, 'encryptRaw'>,
    private readonly metadataRepository: Pick<IMetadataKeyRepository, 'set'>,
  ) {}

  async persist(dbData: Uint8Array, dek: CryptoKey): Promise<void> {
    const { iv, ciphertext } = await this.crypto.encryptRaw(dbData, dek);

    await this.metadataRepository.set(STORAGE_KEYS.DB_ENCRYPTED, {
      algorithm: 'AES-GCM',
      iv: toArrayBuffer(iv),
      data: toArrayBuffer(ciphertext),
    });
  }
}
